import * as React from 'react';
import { connect } from 'react-redux';

type OwnProps = {
  className: string,
  handle: string
};

type StateProps = {
  render: boolean
}

type Props = OwnProps & StateProps;

const CcmCampaignReportingOutfitCreatorHandle = ({
  className,
  handle,
  render
}: Props): null | JSX.Element => (
  render ? (
    <div className={className}>
      @{handle}
    </div>
  ) : null
);

const mapStateToProps = ({ campaignBrief }): StateProps => ({
  render: campaignBrief?.brief?.campaignType === 'ccm'
});

export default connect(mapStateToProps)(CcmCampaignReportingOutfitCreatorHandle);
